module.exports = __webpack_public_path__ + "static/media/tsi_help2.f870ec6b.png";